import { countryCodes } from "./country_codes.js";
import { showToast, showGlobalPreloader, hideGlobalPreloader } from "./utils.js";

document.addEventListener("DOMContentLoaded", () => {
  let signupDataGlobal; // Declare the variable here
  const signupForm = document.getElementById("signup-form");
  const otpForm = document.getElementById("otp-form");
  const countryCodeDropdownOptions = document.querySelector(
    "#country-code-dropdown .dropdown-options",
  );
  const selectedCountryCodeSpan = document.getElementById(
    "selected-country-code",
  );
  const hiddenCountryCodeInput = document.getElementById("country-code");

  // Populate country codes dropdown
  if (countryCodeDropdownOptions && typeof countryCodes !== "undefined") {
    countryCodes.forEach((country) => {
      const a = document.createElement("a");
      a.href = "#";
      a.setAttribute("data-value", country.code);
      a.textContent = `${country.code} (${country.name})`;
      countryCodeDropdownOptions.appendChild(a);
    });

    // Set initial selected value (e.g., India +91)
    const defaultCountry = countryCodes.find(
      (country) => country.code === "+91",
    );
    if (defaultCountry) {
      selectedCountryCodeSpan.textContent = `${defaultCountry.code} (${defaultCountry.name})`;
      hiddenCountryCodeInput.value = defaultCountry.code;
    }
  }

  const phoneInput = document.getElementById("phone");
  const phoneNumberError = document.getElementById("phone-number-error");

  function validatePhoneNumber() {
    const currentPhone = phoneInput.value.trim();
    phoneNumberError.textContent = ""; // Clear previous errors

    const phoneRegex = /^\d*$/; // Only allow digits
    if (!phoneRegex.test(currentPhone)) {
      phoneNumberError.textContent = "Phone number must contain only digits.";
      phoneInput.setCustomValidity("Phone number must contain only digits.");
    } else {
      phoneInput.setCustomValidity("");
    }
  }

  // Add event listeners
  if (phoneInput) {
    phoneInput.addEventListener("input", validatePhoneNumber);
  }

  const countryCodeDropdown = document.getElementById("country-code-dropdown");
  if (countryCodeDropdown) {
    countryCodeDropdown.addEventListener("click", (event) => {
      if (event.target.tagName === "A") {
        // A country code was selected, re-validate phone number
        validatePhoneNumber();
      }
    });
  }

  const OrganizationInput = document.getElementById("organization");
  const OrganizationList = document.getElementById("organization-list");
  let existingOrganizations = [];

  // Function to populate Organization suggestions
  async function populateOrganizationsuggestions() {
    try {
      const response = await fetch("/api/institutions/names");
      if (response.ok) {
        existingOrganizations = await response.json();
        OrganizationList.innerHTML = "";
        existingOrganizations.forEach((inst) => {
          const option = document.createElement("option");
          option.value = inst.name;
          OrganizationList.appendChild(option);
        });
      }
    } catch {
      // Failed to fetch organizations
    }
  }

  // Auto-fill address details when existing Organization is selected
  if (OrganizationInput) {
    OrganizationInput.addEventListener("input", async (e) => {
      const selectedName = e.target.value.trim();
      
      // Clear auto-filled data if name is too short or cleared
      if (!selectedName || selectedName.length < 2) {
        clearAndUnlockFields();
        return;
      }

      // Case-insensitive match from the fetched existing organizations
      const match = existingOrganizations.find(
        (inst) => inst.name.toLowerCase() === selectedName.toLowerCase(),
      );

      if (match) {
        const typeEl = document.getElementById("workplace-type");
        if (typeEl) {
          typeEl.value = match.workplace_type || "School";
        }
        unlockFields();
        showToast(
          `Institution "${match.name}" recognized. Please complete all required organization details.`,
          "info",
        );
      } else {
        unlockFields();
      }
    });
  }

  function clearAndUnlockFields() {
    const fields = ["address", "city", "workplace-type", "country", "state"];
    fields.forEach((id) => {
      const el = document.getElementById(id);
      if (el) {
        el.value = "";
      }
    });
    unlockFields();
  }

  function unlockFields() {
    const fields = ["address", "city", "workplace-type", "country", "state"];
    fields.forEach((id) => {
      const el = document.getElementById(id);
      if (el) {
        el.readOnly = false;
        // Check for custom dropdown wrapper
        const dropdown = el.closest(".custom-dropdown") || document.querySelector(`.custom-dropdown[data-input="${id}"]`);
        if (dropdown) {
          dropdown.style.pointerEvents = "auto";
          dropdown.style.opacity = "1";
          dropdown.style.filter = "none";
        }
        el.style.backgroundColor = "";
        el.style.cursor = "default";
      }
    });
  }

  // Initial population
  populateOrganizationsuggestions();

  // Function to populate country dropdown
  async function populateCountriesDropdown() {
    try {
      const response = await fetch("countries_list.json");
      const countries = await response.json();
      const countryOptions = document.getElementById("country-options");
      if (!countryOptions) return;

      countryOptions.innerHTML = "";
      countries.forEach((countryName) => {
        const a = document.createElement("a");
        a.href = "#";
        a.setAttribute("data-value", countryName);
        a.textContent = countryName;
        countryOptions.appendChild(a);
      });

      // Set default country
      const countryInput = document.getElementById("country");
      const countryDisplay = document.getElementById("selected-country");
      if (countryInput && countries.includes("India")) {
        countryInput.value = "India";
        if (countryDisplay) countryDisplay.textContent = "India";
        populateStatesDropdown("India");
      }
    } catch {
      showToast("Failed to load country list.", "error");
    }
  }

  // Function to populate state dropdown based on selected country
  async function populateStatesDropdown(selectedCountryName) {
    const stateOptions = document.getElementById("state-options");
    if (!stateOptions) return;

    stateOptions.innerHTML = "";
    if (!selectedCountryName) return;

    try {
      const response = await fetch(
        `/api/countries/${encodeURIComponent(selectedCountryName)}/states`,
      );
      if (response.ok) {
        const states = await response.json();
        states.forEach((stateName) => {
          const a = document.createElement("a");
          a.href = "#";
          a.setAttribute("data-value", stateName);
          a.textContent = stateName;
          stateOptions.appendChild(a);
        });
      }
    } catch {
      showToast("Network error loading states.", "error");
    }
  }

  // Event listener for country dropdown change (using custom event from common.js)
  const countryDropdownEl = document.getElementById("country-dropdown");
  if (countryDropdownEl) {
    countryDropdownEl.addEventListener("dropdown-change", (e) => {
      populateStatesDropdown(e.detail.value);
      // Reset state display
      const stateInput = document.getElementById("state");
      const stateDisplay = document.getElementById("selected-state");
      if (stateInput) stateInput.value = "";
      if (stateDisplay) stateDisplay.textContent = "Select State";
    });
  }

  // Initial population of countries dropdown
  populateCountriesDropdown();

  if (signupForm) {
    signupForm.addEventListener("submit", async function (event) {
      event.preventDefault();

      // Run phone number validation before submitting
      validatePhoneNumber();
      if (phoneInput.checkValidity() === false) {
        showToast(phoneNumberError.textContent, "error");
        return;
      }

      const username = document.getElementById("username").value;
      const email = document.getElementById("email").value;
      const countryCode = document.getElementById("country-code").value;
      const phone = document.getElementById("phone").value;
      const fullPhone = countryCode + phone;
      const password = document.getElementById("password").value;
      const confirmPassword = document.getElementById("confirm-password").value;
      const workplaceType = document.getElementById("workplace-type").value;
      const Organization = document.getElementById("organization").value;
      const address = document.getElementById("address").value;
      const city = document.getElementById("city").value;
      const state = document.getElementById("state").value;
      const country = document.getElementById("country").value;

      if (password !== confirmPassword) {
        showToast("Passwords do not match!", "error");
        return;
      }

      showGlobalPreloader("Sending OTP...");

      signupDataGlobal = {
        username,
        email,
        phone: fullPhone,
        phone_country_code: countryCode,
        password,
        institution_name: Organization,
        workplace_type: workplaceType,
        role: "admin",
        address,
        city,
        state,
        country,
      };

      try {
        // Request OTP for signup
        const response = await fetch("/api/auth/request_signup_otp", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(signupDataGlobal),
        });

        if (response.ok) {
          const data = await response.json();
          document.getElementById("global-preloader-message").textContent =
            "OTP Sent Successfully!";
          setTimeout(() => {
            showToast(
              data.message || "OTP sent to your email and phone via sms or voice. Please verify.",
              "success",
            );
            signupForm.style.display = "none"; // Hide signup form
            otpForm.style.display = "block"; // Show OTP form
          }, 1000);
        } else {
          const data = await response.json();
          const errorMessage = data.error || "Failed to send OTP.";
          showToast(errorMessage, "error");
        }
      } catch (error) {
        showToast("Network error requesting OTP: " + error, "error");
      } finally {
        hideGlobalPreloader();
      }
    });
  }

  if (otpForm) {
    otpForm.addEventListener("submit", async function (event) {
      event.preventDefault();
      const submitButton = otpForm.querySelector('button[type="submit"]');
      if (submitButton) {
        submitButton.disabled = true; // Disable button
        submitButton.textContent = 'Verifying...';
      }

      const emailOtpCode = document.getElementById("email-otp-input").value; // New
      const phoneOtpCode = document.getElementById("phone-otp-input").value; // New

      showGlobalPreloader("Verifying OTPs..."); // Updated text

      try {
        // Verify OTPs
        const response = await fetch("/api/auth/verify_signup_otp", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email: signupDataGlobal.email, // Pass email for lookup
            email_otp_code: emailOtpCode,
            phone_otp_code: phoneOtpCode,
          }),
        });

        const data = await response.json();

        if (response.ok) {
          showToast(
            "OTPs verified. Registration request sent. Please wait for the chairman to approve your request. Keep checking email... (Please also check your spam folder.)",
            "success",
          );
          otpForm.style.display = "none"; // Hide OTP form
          // Optionally, redirect or show a success message
        } else {
          const errorMessage = data.error || "OTP verification failed.";
          showToast(errorMessage, "error");
          if (submitButton) submitButton.disabled = false; // Re-enable button on failure
        }
      } catch (error) {
        showToast("Network error verifying OTPs: " + error, "error"); // Updated text
        if (submitButton) submitButton.disabled = false; // Re-enable button on error
      } finally {
        hideGlobalPreloader();
      }
    });
  }
});
